enum SetupWizardSteps {
  GETTING_STARTED = 0,
  PREVIEW_INFO_PEOPLE_AND_COURSES = 1,
  UPLOAD_PEOPLE_AND_COURSES = 2,
  PREVIEW_INFO_TERMS = 3,
  SETUP_TERM = 4,
  PREVIEW_INFO_SURVEY_TEMPLATE = 5,
  CREATE_SURVEY_TEMPLATE = 6,
  PREVIEW_INFO_SURVEY_PROJECT = 7,
  SURVEY_PROJECT_SETUP = 8,
  FINISHED = 9
}

const SetupWizardTitles: Record<number, string> = {
  [SetupWizardSteps.GETTING_STARTED]: 'Getting Started',
  [SetupWizardSteps.PREVIEW_INFO_PEOPLE_AND_COURSES]: '',
  [SetupWizardSteps.UPLOAD_PEOPLE_AND_COURSES]: 'Upload People and Courses',
  [SetupWizardSteps.PREVIEW_INFO_TERMS]: 'Preview Info: Terms',
  [SetupWizardSteps.SETUP_TERM]: 'Set Up Term',
  [SetupWizardSteps.PREVIEW_INFO_SURVEY_TEMPLATE]: '',
  [SetupWizardSteps.CREATE_SURVEY_TEMPLATE]: 'Create Survey Template',
  [SetupWizardSteps.PREVIEW_INFO_SURVEY_PROJECT]: '',
  [SetupWizardSteps.SURVEY_PROJECT_SETUP]: 'Survey Project Setup',
  [SetupWizardSteps.FINISHED]: 'Almost There!'
}

enum PreviewInfoPageSteps {
  PEOPLE_AND_COURSES = 1,
  TERMS = 2,
  SURVEY_TEMPLATE = 3,
  SURVEY_PROJECT = 4
}

const PreviewInfoPageHeaders: Record<number, string> = {
  [PreviewInfoPageSteps.PEOPLE_AND_COURSES]: '1. Upload People and Courses',
  [PreviewInfoPageSteps.TERMS]: '2. Create Term',
  [PreviewInfoPageSteps.SURVEY_TEMPLATE]: '3. Create Survey Template',
  [PreviewInfoPageSteps.SURVEY_PROJECT]: '4. Set Up Survey Project'
}

const PreviewInfoPageDescriptions: Record<number, string> = {
  [PreviewInfoPageSteps.PEOPLE_AND_COURSES]: 'Before creating a term, you must upload information about your institution. This includes faculty, staff, students, and courses.',
  [PreviewInfoPageSteps.TERMS]: 'We will now create a term for your courses. A term is a period of time during which course sections are offered.',
  [PreviewInfoPageSteps.SURVEY_TEMPLATE]: 'Next, we will create a survey template for your courses. A survey template is a set of questions that will be used to evaluate the courses.',
  [PreviewInfoPageSteps.SURVEY_PROJECT]: 'Survey projects manage the distribution and the audience of a survey across one or more academic terms. For each term, you can determine participating course sections, schedule when survey releases, and coordinate communication with all relevant parties.'
}

const termSetupUploadOptions = [
  'courseSections',
  'instructorAssignments',
  'studentEnrollments'
]

enum StatusLabels {
  Default = 'Not Started',
  Pending = 'Pending',
  Success = 'Successful',
  Error = 'Error'
}

const defaultCSVUploadDescription = 'Please upload a CSV file containing the information for this step.'

const wizardKeys = {
  localKey: 'setupTourData',
  UploadPeopleAndCoursesPage: 'upload-people-and-courses',
  SetupTermPage: 'setup-term',
  SetupSurveyTemplatePage: 'setup-survey-template'
}

const currentYear = new Date().getFullYear()

const genericWizardHeaderTooltipFields = {
  requiredFieldText: 'Required Fields:',
  firstName: 'First Name (ex. John)',
  lastName: 'Last Name (ex. Smith)',
  email: 'Email (ex. john.smith@school.edu)',
  id: 'School ID (ex. js12345)',
  password: 'Password (ex. js00000)',
  optionalFieldText: 'Optional Field(s):',
  userAttributes: 'User Attributes (ex. School of Medicine)',
  courseTitle: 'Course Title (ex. Organic Chemistry)',
  abbreviation: 'Abbreviation (ex. CHEM201)',
  parentAcademicUnit: 'Parent Academic Unit (ex. CHEM)',
  courseAttributes: 'Course Attributes (ex. lab)',
  academicUnitType: 'Academic Unit Type (ex. Course)',
  sectionId: 'Section ID (ex. CHEM201-01)',
  startDate: 'Start Date (01/01/2001 08:30AM)',
  endDate: 'End Date (01/01/2001 05:00PM)',
  term: `Term (ex. Fall ${currentYear})`,
  crossListCode: 'Cross List Code (ex. ORGO-201)',
  isPrimaryCourse: 'Is Primary Course (ex. true)',
  role: 'Role (ex. Instructor)',
  academicUnit: 'Academic Unit (ex. CHEM201-01)'
}

const uploadCSVTemplatePaths = {
  faculty: '/UploadCsvTemplates/Faculty_Upload_Template.csv',
  students: '/UploadCsvTemplates/Student_Upload_Template.csv',
  courses: '/UploadCsvTemplates/Courses_Upload_Template.csv',
  courseSections: '/UploadCsvTemplates/Course_Sections_Upload_Template.csv',
  instructorAssignments: '/UploadCsvTemplates/Instructors_Upload_Template.csv',
  studentEnrollments: '/UploadCsvTemplates/Student_Enrollments_Upload_Template.csv'
}

export {
  termSetupUploadOptions,
  StatusLabels,
  defaultCSVUploadDescription,
  wizardKeys,
  currentYear,
  genericWizardHeaderTooltipFields,
  uploadCSVTemplatePaths,
  PreviewInfoPageSteps,
  PreviewInfoPageDescriptions,
  PreviewInfoPageHeaders,
  SetupWizardTitles,
  SetupWizardSteps
}
